import React, { useEffect, useState } from "react";
import PublicRoutes from "./routes/PublicRoutes";
import "bootstrap/dist/css/bootstrap.min.css";
import { loadingImg } from "./constant";
import "core-js";
import WOW from "wowjs";

function App() {
	const [loading, setLoading] = useState(false);
	const [imgload, setImgload] = useState(false);
	console.log(imgload, "Loading is done...");
	useEffect(() => {
		setLoading(true);
		if (imgload !== true) {
			setTimeout(() => {
				setLoading(false);
			}, 7000);
		}
		new WOW.WOW({
			live: false,
		}).init();
	}, []);
	return (
		<React.Fragment>
			{loading ? (
				<div className="loading-wrapper">
					<img
						src={loadingImg}
						onLoad={() => setImgload(true)}
						className="img-fluid"
						id="loading-img"
						alt=""
					/>
				</div>
			) : (
				<PublicRoutes />
			)}
		</React.Fragment>
	);
}

export default App;
